import { createSelector } from "@reduxjs/toolkit";
import { CreditType } from "../../../../shared/api/types.gen.js";
import { cleanObject } from "../../../../shared/lib/utils/cleanObject.js";
import { selectSlice as selectSlice$1 } from "../../../../shared/store/config/model/selectors/selectSlice.js";
import "../../../../shared/store/config/model/slice.js";
import { selectSlice } from "../../../../features/choice/model/selectors/selectSlice.js";
const selectCreditLimitsParams = createSelector([selectSlice, selectSlice$1], (choice, config) => {
  if (!choice.price) {
    return;
  }
  const formattedCreditParams = config.creditParamsFormatter(choice);
  let filteredCreditParams = {};
  if (typeof formattedCreditParams !== "undefined") {
    filteredCreditParams = cleanObject(formattedCreditParams, choice);
  }
  const params = {
    type: choice.type || CreditType.ANNUITY,
    present_value: choice.price,
    ...filteredCreditParams
  };
  return params;
});
export {
  selectCreditLimitsParams
};
